import { Point } from "../../graphicLibs/index";
import { PointInfo } from "../../WalltoFittingInfo";
import { CreatePointData } from "../CreatePointData";
import { WallGrid } from "../WallGrid";


/**
 * 重なっている独立壁を削除する
 * */
export class OverlapWall extends WallGrid {

    constructor(public pointList: PointInfo[]) {
        super(pointList);
    }

    public execute() {

        const pointData = new CreatePointData(this.pointList);
        pointData.execute();
        const branchWall = pointData.branchList;

        if (branchWall.length == 0) return this.pointList;

        branchWall.forEach((index: number) => {
            const nextIndex = Point.nextPoint(index);
            const point = this.pointList[index].point;
            const next = this.pointList[nextIndex].point;
            for (let i = 0; i < this.pointList.length; i+=2) {
                if (i == index || i == nextIndex) continue;
                if (this.pointList[i].isDelete == true || this.pointList[i+1].isDelete == true) continue;
                const start = this.pointList[i].point;
                const end = this.pointList[i+1].point;
                const dir1 = point.clone().sub(start);
                const dir2 = end.clone().sub(start);
                const dir3 = next.clone().sub(start);

                // 線分上にある
                const length = dir2.clone().length();
                const isOnLine = () => - this.e <= (dir1.clone().dot(dir2) / length) && (dir1.clone().dot(dir2) / length) <= length;
                const isOnLine_ = () => - this.e <= (dir3.clone().dot(dir2) / length) && (dir3.clone().dot(dir2) / length) <= length;
                // e以内 高さ方向
                const height1 = dir1.clone().cross(dir2).clone().divideScalar(length);
                const height2 = dir3.clone().cross(dir2).clone().divideScalar(length);
                if (isOnLine() && (height1.clone().length() < this.e)) {
                    if ( isOnLine_() && (height2.clone().length() < this.e)) {
                        this.pointList[index].isDelete = true;
                        this.pointList[nextIndex].isDelete = true;
                    }
                }
            }
        });

        return this.pointList;
    }

    public length(e: number) {
        this.e = e / 1000; /** 単位 mm → m */
    }

}